(ns scittle.impl.common
  (:require [sci.core :as sci]))

(def cljns (sci/create-ns 'clojure.core nil))
